import * as React from "react";
import { MessageBar, MessageBarType, useTheme } from "@fluentui/react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { getICalendarDeprecationBannerClassNames, iCalendarDeprecationBannerContainerStyles } from "./ICalendarDeprecationBanner.styles";
/**
 * Dismissible banner component that shows iCalendar deprecation message in UNO
 * All checking (flight, iCalendar enabled, dismissal) is handled by the container component
 * Only shows for the legacy app (not the new evo app)
 */ export const ICalendarDeprecationBanner = ({ onDismiss })=>{
    const theme = useTheme();
    const classNames = getICalendarDeprecationBannerClassNames(theme);
    const handleDismiss = ()=>{
        onDismiss();
    };
    const headsUpText = Strings.ICalendarDialog_DeprecationHeadsUp;
    const restOfMessage = " " + Strings.ICalendarDialog_DeprecationSubtext;
    return /*#__PURE__*/ React.createElement(MessageBar, {
        messageBarType: MessageBarType.warning,
        onDismiss: handleDismiss,
        dismissButtonAriaLabel: Strings.SharedComponents_CloseButtonText,
        styles: iCalendarDeprecationBannerContainerStyles(theme)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.message
    }, /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("span", {
        className: classNames.boldText
    }, headsUpText), /*#__PURE__*/ React.createElement("span", null, restOfMessage))));
};
